;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"3db157a492656de16ed76ca082d425c36a46765e"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.3.6";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/offline/11namme/survey/:applicationId\",\"regex\":\"^/offline/11namme/survey/([^/]+)$\",\"paramNames\":[\"applicationId\"],\"hasOptionalPrefix\":false},{\"path\":\"/playroom/:locale\",\"regex\":\"^/playroom/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/playroom/:locale/:gameSettingsId\",\"regex\":\"^/playroom/([^/]+)/([^/]+)$\",\"paramNames\":[\"locale\",\"gameSettingsId\"],\"hasOptionalPrefix\":true},{\"path\":\"/playroom/:locale/review\",\"regex\":\"^/playroom/([^/]+)/review$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/playroom/form/marketing/:locale\",\"regex\":\"^/playroom/form/marketing/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/playroom/form/playtest/:locale\",\"regex\":\"^/playroom/form/playtest/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/project/:id\",\"regex\":\"^/project/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/design-system\"},{\"path\":\"/legacy/game-orb/demoday\"},{\"path\":\"/legacy/game-orb/devils-plan\"},{\"path\":\"/legacy/game-orb/real_genius\"},{\"path\":\"/legacy/love-buddies/day_nammae\"},{\"path\":\"/legacy/love-buddies/detail\"},{\"path\":\"/legacy/love-buddies/detail2\"},{\"path\":\"/legacy/socialing\"},{\"path\":\"/legacy/socialing/game-orb\"},{\"path\":\"/legacy/socialing/game-orb/event\"},{\"path\":\"/legacy/socialing/love-buddies\"},{\"path\":\"/offline\"},{\"path\":\"/offline/11namme\"},{\"path\":\"/offline/11namme/apply\"},{\"path\":\"/offline/mafia\"},{\"path\":\"/offline/manito\"},{\"path\":\"/playroom\"},{\"path\":\"/playroom/form/marketing\"},{\"path\":\"/playroom/form/playtest\"},{\"path\":\"/playroom/review\"},{\"path\":\"/playroom_hide\"},{\"path\":\"/project\"}],\"isrRoutes\":[\"/project/:id\"]}";import * as Sentry from "@sentry/nextjs";
import {
  getClientSentryDebugContext,
  getHydrationDebugContext,
  shouldIgnoreKnownInAppBrowserError,
} from "@/lib/sentry-debug";

const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  "https://48048aa74886bdd547d8c06d056afe2a@o4505765760204800.ingest.us.sentry.io/4511094127788032";
const SENTRY_ENVIRONMENT =
  process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.NODE_ENV || "development";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  sendDefaultPii: false,
  tracesSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  integrations: [Sentry.replayIntegration()],
  maxValueLength: 1024,
  normalizeDepth: 5,
  initialScope: (scope) => {
    scope.setTag("runtime", "client");
    return scope;
  },
  beforeBreadcrumb: (breadcrumb) => {
    if (breadcrumb.category === "console" && breadcrumb.level === "log") {
      return null;
    }

    return breadcrumb;
  },
  beforeSend: (event) => {
    const debugContext = getClientSentryDebugContext();
    const hydrationDebugContext = getHydrationDebugContext(event);

    event.tags = {
      ...debugContext.tags,
      ...hydrationDebugContext?.tags,
      ...event.tags,
    };
    event.contexts = {
      ...event.contexts,
      ...debugContext.contexts,
    };
    event.extra = {
      ...debugContext.extra,
      ...hydrationDebugContext?.extra,
      ...event.extra,
    };

    if (shouldIgnoreKnownInAppBrowserError(event)) {
      return null;
    }

    return event;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
